module.exports = __webpack_public_path__ + "img/plus_navy.44a5fc49.svg";